import axios from "axios";
import { Base_URL } from "../url";

export const saveBankDetails = async (bankData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(`${Base_URL}/BankMaster/CreateBank?UserName=${userId}`, bankData);
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving bank details!";
  }
};

export const getAllCompanyCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CompanyCode/GetAll`);
    return response.data.map(company => ({
      companyCode: company.companyCode,
      name: company.name
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching company codes!";
  }
};